// Icons
import { FaUserAlt } from "react-icons/fa";

// Types
import type { IProfileProps } from "./types";

export function Profile({REP_PROJECT,infocusID, clientCompletions}: IProfileProps) {

    return (
      <div data-infocusID={infocusID === 4}
       className="md:absolute
            print:!relative
            print:!left-0
            border-[1px] border-r-[#000]
            last-of-type:border-none
            opacity-100 -left-[100%]
            data-[inFocusID=true]:opacity-0
            data-[inFocusID=true]:left-0
            transition-all duration-[0.38s]
            w-full h-screen flex flex-row justify-between gap-4 p-16 bg-white
            page-break
        "
      >
            <div className="w-[75%] flex flex-col justify-between gap-16 py-16">
                <span className="w-full h-auto flex flex-col  gap-4">
                    <span className="text-5xl">Perfil do <span className="text-5xl font-bold">Cliente</span> </span>
                </span>

                <ul className="font-normal text-2xl  text-left md:max-w-[70%] flex flex-col gap-4">
                    <li className="relative after:absolute after:w-2 after:h-2 after:bg-black after:rounded-full after:-left-4 after:top-4">{clientCompletions?.choices[0].message.content}</li>
                    <li className="relative after:absolute after:w-2 after:h-2 after:bg-black after:rounded-full after:-left-4 after:top-4">Renda média dos compradores são de {Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(REP_PROJECT?.average_income_value || 0)}</li>
                    <li className="relative after:absolute after:w-2 after:h-2 after:bg-black after:rounded-full after:-left-4 after:top-4">A maioria dos compradores são de São Paulo*.</li>
                    <li className="relative after:absolute after:w-2 after:h-2 after:bg-black after:rounded-full after:-left-4 after:top-4">A maioria das aquisições são à vista ou parcelado sem a necessidade de financiamento*.</li>
                    <li className="relative after:absolute after:w-2 after:h-2 after:bg-black after:rounded-full after:-left-4 after:top-4">Faixa etária média de {REP_PROJECT?.average_age_residents} anos.</li>
                </ul>

                <span className="w-full h-48 px-24 flex flex-row flex-nowrap items-center justify-between rounded-2xl gap-4 bg-[#cde9e1] relative">
                    <span className="flex items-center justify-center w-24 h-24 bg-[#079269] rounded-3xl absolute left-0 -translate-x-1/2 top-1/2 -translate-y-1/2">
                        <FaUserAlt size={24} className="text-white" />
                    </span>

                    <span className="min-w-[25%] flex flex-col gap-2 font-medium text-xl border-r-[2px] border-[#008fd6] pr-16 last-of-type:border-none">
                        <span className="text-gray-400">Pagamento</span>
                        <span>À vista ou parcelado*</span>
                    </span>

                    <span className="min-w-[25%] flex flex-col gap-2 font-medium text-xl border-r-[2px] border-[#008fd6] pr-16 last-of-type:border-none">
                        <span className="text-gray-400">Renda média </span>
                        <span>{Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(REP_PROJECT?.average_income_value || 0)}</span>
                    </span>

                    <span className="min-w-[25%] flex flex-col gap-2 font-medium text-xl border-r-[2px] border-[#008fd6] pr-16 last-of-type:border-none">
                        <span className="text-gray-400">Faixa etária</span>
                        <span>{REP_PROJECT?.average_age_residents} anos</span>
                    </span>
                </span>
            </div>

            <div className="flex-1 h-full bg-slate-200 rounded-tl-[46px] rounded-bl-[46px]">

            </div>
        </div>
    )
}
